import { LoadableAfterPaint } from '@confluence/loadable';

import { RendererContentStatePlaceholder } from './RendererContentState/RendererContentStatePlaceholder.tsx';

export const LazyEditorContentStateComponent = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-EditorContentStateEditorContentStateComponent" */ './EditorContentState/EditorContentStateComponent.tsx'
			)
		).EditorContentStateComponent;
	},
});

export const LazyRendererContentStateComponent = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentStateComponent" */ './RendererContentState/RendererContentStateComponent.tsx'
			)
		).RendererContentStateComponent;
	},
	loading: RendererContentStatePlaceholder,
});
